import React, { useEffect, useState } from 'react';
import { Popover } from 'antd';
import { ChevronDown } from '../../assets/icons';
import { Link } from 'react-router-dom';
import { useScrollTop } from '../../Hooks/useScrollTop';
import LogoutModal from '../LogoutModal/LogoutModal';
import './SidebarMobile.scss';

const SidebarMobile = (props) => {
  const { popPage, setPopPage } = props;
  const [popOpen, setPopOpen] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);

  useEffect(() => {
    switch (window.location.pathname) {
      case '/account/': {
        setPopPage('Profile');
        break;
      }
      case '/account': {
        setPopPage('Profile');
        break;
      }
      case '/account/transactions': {
        setPopPage('Balances & Transactions');
        break;
      }
      case '/account/payment': {
        setPopPage('Payment Methods');
        break;
      }
      case '/account/documents': {
        setPopPage('Documents');
        break;
      }
      case '/account/settings': {
        setPopPage('Settings');
        break;
      }
      case '/account/help-center': {
        setPopPage('Help Center');
        break;
      }
      case '/account/legal': {
        setPopPage('Legal');
        break;
      }
      case '/account/affiliate-program': {
        setPopPage('Referral Program');
        break;
      }
      default: {
        setPopPage(0);
        break;
      }
    }
  }, [window.location.pathname]);

  const { ref, isTop } = useScrollTop(0);
  return (
    <div className='sidebarmobile' ref={ref}>
      <div id='sidebar-mobile-container' className={isTop ? 'top' : 'no-top'} />
      <Popover
        open={popOpen}
        overlayClassName='sidebarmobile__popup'
        getPopupContainer={() => document.getElementById('sidebar-mobile-container')}
        content={
          <ul>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Profile');
                }}
                to='/account'
              >
                Profile
              </Link>
            </li>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Balances & Transactions');
                }}
                to='/account/transactions'
              >
                Balances & Transactions
              </Link>
            </li>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Payment Methods');
                }}
                to='/account/payment'
              >
                Payment Methods
              </Link>
            </li>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Documents');
                }}
                to='/account/documents'
              >
                Documents
              </Link>
            </li>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Settings');
                }}
                to='/account/settings'
              >
                Settings
              </Link>
            </li>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Help Center');
                }}
                to='/account/help-center'
              >
                Help Center
              </Link>
            </li>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Legal');
                }}
                to='/account/legal'
              >
                Legal
              </Link>
            </li>
            <li className='sidebarmobile__item'>
              <Link
                onClick={() => {
                  setPopOpen(false);
                  setPopPage('Referral Program');
                }}
                to='/account/affiliate-program'
              > 
                 Referral Program
              </Link>
            </li>
            <li className='sidebarmobile__item' onClick={() => setLogoutModal(true)}>
              <span to=''>Log out</span>
            </li>
          </ul>
        }
      >
        <div className='sidebar-trigger' onClick={() => setPopOpen(!popOpen)}>
          {popPage} <ChevronDown marginLeft='16px' />
        </div>
      </Popover>
      <LogoutModal logoutModal={logoutModal} setLogoutModal={setLogoutModal} />
    </div>
  );
};

export default SidebarMobile;
